<button type="button" class="btn btn-info-outline" [class.btn-sm]="sm" (click)="whBack()">
    <clr-icon shape="undo"></clr-icon>
    Back
</button>